const TZ = "Europe/Paris";

export const fmtDate = (iso) =>
  new Intl.DateTimeFormat("fr-FR", { weekday: "long", day: "numeric", month: "long", timeZone: TZ }).format(new Date(iso));

export const fmtShortDate = (iso) =>
  new Intl.DateTimeFormat("fr-FR", { day: "2-digit", month: "short", year: "numeric", timeZone: TZ }).format(new Date(iso));

export const fmtTime = (iso) =>
  new Intl.DateTimeFormat("fr-FR", { hour: "2-digit", minute: "2-digit", timeZone: TZ }).format(new Date(iso)).replace(":", "h");

export const fmtPrice = (n) => `${Number(n).toLocaleString("fr-FR", { minimumFractionDigits: n % 1 ? 2 : 0 })} €`;

export const toLocalInput = (iso) => {
  const p = new Intl.DateTimeFormat("sv-SE", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }).format(new Date(iso));
  return p.replace(" ", "T");
};

export const CATEGORIES = [
  { key: "tous", label: "Tous" },
  { key: "rencontres", label: "Rencontres" },
  { key: "affaires", label: "Affaires" },
  { key: "gastronomie", label: "Gastronomie" },
  { key: "copines", label: "Copines & Bulles" },
];

export const catLabel = (k) => CATEGORIES.find((c) => c.key === k)?.label || k;

export const INSTANT_STATUS = {
  nouvelle: "Nouvelle",
  en_cours: "En cours",
  acceptee: "Acceptée",
  refusee: "Refusée",
};
